// FE-SCRM-054 — TanStack-Query wrapper around /api/v1/sales/search.
//
// Hook consumers pass the live query string; the hook short-circuits
// for queries shorter than the 2-char minimum (matching BE-SCRM-054's
// server-side contract) so a 1-char keystroke never fires a request.
// Debouncing is the modal's job — the hook only owns the request +
// cache layer.

import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { fetchGlobalSearch } from "./api";
import type { GlobalSearchResponse } from "./types";


const MIN_QUERY_LENGTH = 2;
export const GLOBAL_SEARCH_QUERY_KEY = "sales-global-search" as const;


const EMPTY_PAYLOAD: GlobalSearchResponse = {
  prospects: [],
  sales_contacts: [],
  opportunities: [],
  carriers: [],
  carrier_contacts: [],
};


export function useGlobalSearch(
  q: string,
  opts?: { limit?: number },
): UseQueryResult<GlobalSearchResponse> {
  const trimmed = q.trim();
  const enabled = trimmed.length >= MIN_QUERY_LENGTH;
  return useQuery({
    queryKey: [GLOBAL_SEARCH_QUERY_KEY, trimmed, opts?.limit ?? null],
    queryFn: ({ signal }) =>
      fetchGlobalSearch(trimmed, { signal, limit: opts?.limit }),
    enabled,
    initialData: enabled ? undefined : EMPTY_PAYLOAD,
    staleTime: 30_000,
  });
}
